var React = require('react');

function F2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"F2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"53.65 20.75 52.3 0 4.59 3.29 18.74 23.49 53.65 20.75","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"1 2.79 0.74 23.58 0.63 32.41 0.37 53.2 0 82.81 23.07 83.1 23.33 62.31 23.44 53.48 49.43 53.81 49.69 33.02 23.7 32.69 23.85 21.08 1 2.79","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

F2.defaultProps = {"viewBox":"0 0 53.65 83.1"};

module.exports = F2;

F2.default = F2;
